import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // user shape: null (loading) | false (guest) | { role: "admin", ... } | { role: "member", ... }
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Try admin first; if no admin session, try member
    (async () => {
      try {
        const r = await api.get("/auth/me");
        setUser({ ...r.data, role: "admin" });
        return;
      } catch {}
      try {
        const r = await api.get("/auth/member/me");
        setUser({ ...r.data, role: "member" });
      } catch { setUser(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser({ ...data, role: "admin" });
    return data;
  };

  const memberLogin = async (identifier, password) => {
    const { data } = await api.post("/auth/member/login", { identifier, password });
    if (data.otp_required) return data; // new device — caller must call verifyLoginOtp next
    setUser({ ...data, role: "member" });
    return data;
  };

  const verifyLoginOtp = async (otpToken, otp) => {
    const { data } = await api.post("/auth/member/login/verify-otp", { otp_token: otpToken, otp });
    setUser({ ...data, role: "member" });
    return data;
  };

  const resendLoginOtp = async (otpToken) => {
    const { data } = await api.post("/auth/member/login/resend-otp", { otp_token: otpToken });
    return data;
  };

  const logout = async () => {
    try {
      if (user?.role === "member") await api.post("/auth/member/logout");
      else await api.post("/auth/logout");
    } catch {}
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, memberLogin, verifyLoginOtp, resendLoginOtp, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
